export default __webpack_public_path__ + "static/footer-background-b8b8783aef3e8faf733df8b8db2904b0.png";